function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { RecursionField, useField, useFieldSchema } from '@formily/react';
import { Card, Empty } from 'antd';
import cls from 'classnames';
import React from 'react';
import { useCssInJs, wrapReactionHook } from "../../hooks";
import { ArrayBase } from "../ArrayBase";
import genArrayCardsStyles from "./style";
var isAdditionComponent = function isAdditionComponent(schema) {
  var _schema$xComponent;
  return ((_schema$xComponent = schema['x-component']) === null || _schema$xComponent === void 0 ? void 0 : _schema$xComponent.indexOf('Addition')) > -1;
};
var isIndexComponent = function isIndexComponent(schema) {
  var _schema$xComponent2, _schema$xComponent2$i;
  return ((_schema$xComponent2 = schema['x-component']) === null || _schema$xComponent2 === void 0 || (_schema$xComponent2$i = _schema$xComponent2.indexOf) === null || _schema$xComponent2$i === void 0 ? void 0 : _schema$xComponent2$i.call(_schema$xComponent2, 'Index')) > -1;
};
var isRemoveComponent = function isRemoveComponent(schema) {
  var _schema$xComponent3, _schema$xComponent3$i;
  return ((_schema$xComponent3 = schema['x-component']) === null || _schema$xComponent3 === void 0 || (_schema$xComponent3$i = _schema$xComponent3.indexOf) === null || _schema$xComponent3$i === void 0 ? void 0 : _schema$xComponent3$i.call(_schema$xComponent3, 'Remove')) > -1;
};
var isCopyComponent = function isCopyComponent(schema) {
  var _schema$xComponent4, _schema$xComponent4$i;
  return ((_schema$xComponent4 = schema['x-component']) === null || _schema$xComponent4 === void 0 || (_schema$xComponent4$i = _schema$xComponent4.indexOf) === null || _schema$xComponent4$i === void 0 ? void 0 : _schema$xComponent4$i.call(_schema$xComponent4, 'Copy')) > -1;
};
var isMoveUpComponent = function isMoveUpComponent(schema) {
  var _schema$xComponent5, _schema$xComponent5$i;
  return ((_schema$xComponent5 = schema['x-component']) === null || _schema$xComponent5 === void 0 || (_schema$xComponent5$i = _schema$xComponent5.indexOf) === null || _schema$xComponent5$i === void 0 ? void 0 : _schema$xComponent5$i.call(_schema$xComponent5, 'MoveUp')) > -1;
};
var isMoveDownComponent = function isMoveDownComponent(schema) {
  var _schema$xComponent6, _schema$xComponent6$i;
  return ((_schema$xComponent6 = schema['x-component']) === null || _schema$xComponent6 === void 0 || (_schema$xComponent6$i = _schema$xComponent6.indexOf) === null || _schema$xComponent6$i === void 0 ? void 0 : _schema$xComponent6$i.call(_schema$xComponent6, 'MoveDown')) > -1;
};
var isOperationComponent = function isOperationComponent(schema) {
  return isAdditionComponent(schema) || isRemoveComponent(schema) || isCopyComponent(schema) || isMoveDownComponent(schema) || isMoveUpComponent(schema);
};
export var InternalArrayCards = wrapReactionHook(function (props) {
  var field = useField();
  var schema = useFieldSchema();
  var dataSource = Array.isArray(field.value) ? field.value : [];
  var prefix = 'form-array-cards';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genArrayCardsStyles
    }),
    hashId = _useCssInJs.hashId,
    wrapSSR = _useCssInJs.wrapSSR;
  if (!schema) return null;
  // if (!schema) throw new Error('can not found schema object')

  var renderItems = function renderItems() {
    return dataSource === null || dataSource === void 0 ? void 0 : dataSource.map(function (_i, index) {
      var items = Array.isArray(schema.items) ? schema.items[index] || schema.items[0] : schema.items;
      console.log('items', {
        items: items
      });
      var title = /*#__PURE__*/React.createElement("span", null, items ? /*#__PURE__*/React.createElement(RecursionField, {
        schema: items,
        name: index,
        filterProperties: function filterProperties(schema) {
          if (!isIndexComponent(schema)) return false;
          return true;
        },
        onlyRenderProperties: true
      }) : null, props.title || field.title);
      var extra = /*#__PURE__*/React.createElement("span", null, items ? /*#__PURE__*/React.createElement(RecursionField, {
        schema: items,
        name: index,
        filterProperties: function filterProperties(schema) {
          if (!isOperationComponent(schema)) return false;
          return true;
        },
        onlyRenderProperties: true
      }) : null, props.extra);
      var content = items ? /*#__PURE__*/React.createElement(RecursionField, {
        schema: items,
        name: index,
        filterProperties: function filterProperties(schema) {
          if (isIndexComponent(schema)) return false;
          if (isOperationComponent(schema)) return false;
          return true;
        }
      }) : null;
      return /*#__PURE__*/React.createElement(ArrayBase.Item, {
        key: index,
        index: index,
        record: function record() {
          var _field$value;
          return (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value[index];
        }
      }, /*#__PURE__*/React.createElement(Card, _extends({}, props, {
        onChange: function onChange() {},
        className: cls("".concat(prefix, "-item"), hashId, props.className),
        title: title,
        extra: extra
      }), content));
    });
  };
  var renderAddition = function renderAddition() {
    return schema.reduceProperties(function (addition, schema, key) {
      if (isAdditionComponent(schema)) {
        return /*#__PURE__*/React.createElement(RecursionField, {
          schema: schema,
          name: key
        });
      }
      return addition;
    }, null);
  };
  var renderEmpty = function renderEmpty() {
    if (dataSource !== null && dataSource !== void 0 && dataSource.length) return;
    return /*#__PURE__*/React.createElement(Card, _extends({}, props, {
      onChange: function onChange() {},
      className: cls("".concat(prefix, "-item"), hashId, props.className),
      title: props.title || field.title
    }), /*#__PURE__*/React.createElement(Empty, null));
  };
  return wrapSSR( /*#__PURE__*/React.createElement(ArrayBase, null, renderEmpty(), renderItems(), renderAddition()));
});
export var ArrayCards = ArrayBase.mixin(InternalArrayCards);
ArrayCards.displayName = 'ArrayCards';
export default ArrayCards;